function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 284.929,
  height: 180,
  viewBox: "0 55 284.929 180",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m282.082 76.511-14.274-14.273q-2.854-2.858-6.57-2.856-3.708-.002-6.563 2.856L142.466 174.441 30.262 62.241q-2.855-2.858-6.567-2.856-3.713-.002-6.567 2.856L2.856 76.515Q-.001 79.369 0 83.082q0 3.71 2.856 6.565l133.043 133.046q2.854 2.854 6.567 2.854c3.713 0 4.661-.951 6.562-2.854L282.082 89.647c1.902-1.903 2.847-4.093 2.847-6.565 0-2.475-.945-4.665-2.847-6.571"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-angle-down.svg";
export { SvgComponent as ReactComponent };